<template>
  <div id="Jigyounushi">
    <div class="section-1">
      <div class="strong-font mt-divide">
        <p v-for="item in this.belongText.title" :key="item.id">
          {{ item }}
        </p>
      </div>

      <div class="mt-divide">
        <img :src="this.belongText.symbol_img" class="symbol" />
        <text-box
          :text="belongText.target_ja + 'なんだけど...'"
          :isInactive="true"
        ></text-box>
      </div>

      <div class="mt-divide">
        <ul>
          <li
            v-for="(item, index) in requirementList"
            :key="item.id"
            class="select-item"
          >
            <select-box
              :text="item.item"
              v-model="requirementFlag[index]"
            ></select-box>
          </li>
        </ul>
      </div>
    </div>
    <div id="result_list" class="mt-divide">
      <ul>
        <li class="result-item" v-for="item in this.resultList" :key="item.id">
          <benefit-card :item="item"></benefit-card>
        </li>
      </ul>
    </div>
    <a @click="showResult" class="result-btn">
      <p>{{ resultBtnText }}</p>
    </a>
    <div class="result-btn-dummy"></div>
  </div>
</template>

<script>
import TextBox from '@/components/RoundedTextBox'
import SelectBox from '@/components/SelectBox'
import BenefitCard from '@/components/BenefitCard'
export default {
	name: 'Diag',
	data(){
		return{
      belongText:{},
			requirementList:{},
			requirementFlag:[],
			resultList:[],
			isResultUpdated:false,
			isResultShowed:false
		}
	},
	components: {
    TextBox,
		SelectBox,
		BenefitCard
  },
  created() {
    const belong = this.$route.query.belong
    // 事業主の場合
    if(belong=='Jigyounushi'){
      this.belongText={
        title:[
          "事業主のあなたが受けられる可能性の高い支援金を診断します。",
          "当てはまるボタンにチェックしてください。"
        ],
        symbol_img : 'img/jigyounushi.png',
        target : 'Jigyounushi',
        target_ja : '事業主'
      }
    }
    // 個人の場合
    else if(belong=='Kojin'){
      this.belongText={
        title:[
          "個人のあなたが受けられる可能性の高い支援金を診断します。",
          "当てはまるボタンにチェックしてください。"
        ],
        symbol_img : 'img/kojin.png',
        target : 'Kojin',
        target_ja : '個人'
      }
    }
    // それ以外は元ページにリダイレクト
    else{
      this.$router.push('/')
      return 
    }
  },
	mounted() {
		this.axios.get(`requirement/?belong=${this.belongText.target_ja}`).then(res =>{
        this.requirementList = res.data
				for(let i = 0; i < this.requirementList.length; i++){
					this.requirementFlag[i] = false
				}
      }).catch(err =>{
        console.log(err)
      })
	},
	computed:{
		resultBtnText(){
			const ret = this.isResultShowed ? 'はじめから' : '現在の選択肢で結果を見る'
			return ret
		}
	},
	methods: {
		showResult(){
			// 結果を見るボタンが押された場合
			if(!this.isResultShowed){
				let selectedRequirement = []
				for(let i = 0; i < this.requirementList.length; i++)
					if(this.requirementFlag[i])selectedRequirement.push(this.requirementList[i].item)
				if(selectedRequirement.length == 0) selectedRequirement = 'だれでも'
				else selectedRequirement = selectedRequirement.join(',')
        
				this.axios.get(`benefit/?belong=${this.belongText.target_ja}&requirement=${selectedRequirement}`).then(res =>{
					this.resultList = res.data
				}).catch(err =>{
          console.log(err)
        })
			}
			else{
				this.$router.push('/')
			}

			this.isResultShowed = !this.isResultShowed
		}
	},
	watch: {
		requirementFlag:{
			handler:function(){
				this.isResultShowed = false
			}

		},
    resultList: {
			handler:function () {
				this.isResultUpdated = true // resultが更新されたという状態に変化
    },
		deep:true}
  },
	updated() {
		if(this.isResultUpdated){
			document.getElementById("result_list").scrollIntoView({behavior: "smooth", block: "start"});
			this.isResultUpdated = false // resultが更新終了
		}
	},
}
</script>

<style scoped>
.section-1 {
  width: 80%;
  margin: 0 auto;
}

img.symbol {
  display: block;
  width: 80%;
  margin: 0 auto;
}

.select-item {
  padding-bottom: 1.2em;
}

.result-item {
  margin: 30px 10px;
}

.result-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 2em 0;
  font-size: 1.1em;
  text-align: center;
  text-decoration: underline;
  color: var(--main-color);
  background-color: var(--bg-color);
  box-shadow: 0px -7px 20px 0px rgba(0, 0, 0, 0.2);
}
.result-btn-dummy {
  height: 8em;
}
</style>